"use strict";

module.exports = require("./is-implemented")() ? Number.isNaN : require("./shim");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/number/is-nan/index.js
// module id = ../../../node_modules/es5-ext/number/is-nan/index.js
// module chunks = 1